import slice from "./contactUsSlice";

export default slice.reducer;
